import { CampusWard } from '../ecclesiastical/campus-ward.model';
import { ApprovedAddress } from './approved-address.model';

export class CampusWardSessionInformation {
    campusWard: CampusWard;
    assignedApprovedAddresses: ApprovedAddress[];
}
